var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50033 3.1407L14.2188 3.1407C14.6258 3.1407 14.9559 2.81075 14.9559 2.40366C14.9559 1.99657 14.6258 1.66663 14.2188 1.66663L6.50033 1.66663C6.09327 1.66663 6.1467 1.99661 6.1467 2.40366C6.1467 2.81072 6.09327 3.1407 6.50033 3.1407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40403 3.1407L3.912 3.1407C4.31906 3.1407 3.98237 2.81072 3.98237 2.40366C3.98237 1.99661 4.31906 1.66663 3.912 1.66663L1.40403 1.66663C0.996971 1.66663 0.666992 1.99661 0.666992 2.40366C0.666992 2.81072 0.996971 3.1407 1.40403 3.1407Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0648 1.33331C4.57451 1.33331 4.1748 1.733 4.1748 2.22331C4.1748 2.71363 4.57451 3.11331 5.0648 3.11331C5.55512 3.11331 5.9548 2.71361 5.9548 2.22331C5.9548 1.73302 5.5551 1.33331 5.0648 1.33331ZM3.1748 2.22331C3.1748 1.1807 4.02224 0.333313 5.0648 0.333313C6.10738 0.333313 6.9548 1.18074 6.9548 2.22331C6.9548 3.26588 6.10742 4.11331 5.0648 4.11331C4.02224 4.11331 3.1748 3.26593 3.1748 2.22331Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9343 7.80739H14.2188C14.6259 7.80739 14.9559 7.47738 14.9559 7.07035C14.9559 6.66326 14.6258 6.33331 14.2188 6.33331L10.9343 6.33331C10.5273 6.33331 10.864 6.66326 10.864 7.07035C10.864 7.47738 10.5273 7.80739 10.9343 7.80739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40403 7.80739L8.62927 7.80739C9.03636 7.80739 8.69964 7.47735 8.69964 7.07035C8.69964 6.66326 9.03627 6.33331 8.62927 6.33331L1.40403 6.33331C0.996971 6.33331 0.666992 6.66329 0.666992 7.07035C0.666992 7.47735 0.996939 7.80739 1.40403 7.80739Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78258 6C9.29226 6 8.89258 6.39968 8.89258 6.89C8.89258 7.38032 9.29228 7.78 9.78258 7.78C10.2729 7.78 10.6726 7.38028 10.6726 6.89C10.6726 6.39972 10.2729 6 9.78258 6ZM7.89258 6.89C7.89258 5.84739 8.73997 5 9.78258 5C10.8252 5 11.6726 5.84742 11.6726 6.89C11.6726 7.93259 10.8251 8.78 9.78258 8.78C8.74001 8.78 7.89258 7.93262 7.89258 6.89Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70471 12.474L14.2188 12.474C14.6259 12.474 14.9559 12.144 14.9559 11.737C14.9559 11.3299 14.6259 10.9999 14.2188 10.9999L7.70471 10.9999C7.29768 10.9999 7.63434 11.3299 7.63434 11.737C7.63434 12.144 7.29768 12.474 7.70471 12.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40403 12.474H5.39964C5.80673 12.474 5.47001 12.144 5.47001 11.737C5.47001 11.33 5.80673 10.9999 5.39964 10.9999H1.40403C0.996939 10.9999 0.666992 11.33 0.666992 11.737C0.666992 12.144 0.996939 12.474 1.40403 12.474Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55307 10.6666C6.06278 10.6666 5.66309 11.0663 5.66309 11.5566C5.66309 12.0469 6.06279 12.4466 6.55307 12.4466C7.04335 12.4466 7.44305 12.0469 7.44305 11.5566C7.44305 11.0663 7.04336 10.6666 6.55307 10.6666ZM4.66309 11.5566C4.66309 10.514 5.51051 9.66663 6.55307 9.66663C7.59563 9.66663 8.44305 10.514 8.44305 11.5566C8.44305 12.5992 7.59564 13.4466 6.55307 13.4466C5.5105 13.4466 4.66309 12.5992 4.66309 11.5566Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5c8df8f65f5dee36acf1dd64c4525341.svg";
export { ForwardRef as ReactComponent };